import styled from 'styled-components/macro';
import * as colors from '../../../../components/common/colorConstants';
import { mediumHeightScreens, smallScreens } from '../../../../components/common/fontElements';

// height needed for force scoll in grid
export const NoResultsWrapper = styled.div`
  height: 10px;
  padding: 40px;
`;

export const Title = styled.p`
  font-family: Lato, sans-serif;
  font-size: 14px;
  color: ${colors.darkGray9};
  margin: 0;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
  }
`;
